import { loadingActions } from 'modules/loading';
import { CMS_POPUP_SEGMENTATION_TYPE, CMS_POPUP_TYPE } from 'constants/cms';
import { cmsAction } from '.';
import CmsApi from './repository';

export const getCmsPage = (path) => async (dispatch) => {
  dispatch(loadingActions.show());
  dispatch(cmsAction.getPage(path));
  return CmsApi.getPage(path)
    .then((data) => {
      dispatch(cmsAction.getPageSuccess({ path, blocks: data?.activeVersion?.body || null }));
      dispatch(loadingActions.hide());
      return true;
    })
    .catch((error) => {
      dispatch(cmsAction.getPageFail({ path, error: error?.message || error }));
      dispatch(loadingActions.hide());
      return false;
    });
};

const isDisplayablePopup = (popup) => popup.enabled && popup.type !== CMS_POPUP_TYPE.PUSH;

export const getCmsPopups = () => async (dispatch) => {
  dispatch(cmsAction.getPopups());
  try {
    const response = await CmsApi.getPopups();
    // WHITE_LIST popups are user-targeted server-side; exclude them from the
    // general list so they are not shown to users outside the whitelist.
    const generalPopups = response.content.filter(
      (popup) => isDisplayablePopup(popup) && popup.rules?.segmentation?.type !== CMS_POPUP_SEGMENTATION_TYPE.WHITE_LIST,
    );

    dispatch(cmsAction.getPopupsSuccess(generalPopups));
    return true;
  } catch (error) {
    dispatch(cmsAction.getPopupsFail(error?.message || error));
    return false;
  }
};

// WHITE_LIST popups are user-targeted; fetched only once the session is
// authenticated (clientId available) and stored separately from general popups.
export const getCmsUserPopups = () => async (dispatch, getState) => {
  const clientId = getState().session?.user?.clientId;
  if (!clientId) {
    return false;
  }
  try {
    const userPopups = await CmsApi.getPopupsByUser(clientId);
    const whitelistPopups = (userPopups || []).filter(isDisplayablePopup);
    dispatch(cmsAction.getUserPopupsSuccess(whitelistPopups));
    return true;
  } catch (error) {
    dispatch(cmsAction.getUserPopupsSuccess([]));
    return false;
  }
};

export const getCmsDocument = (hash) => {
  return CmsApi.getDocument(hash);
};
